import { z } from 'zod'
import { COLUMN_BYTES } from '../../../lib/columnBytes'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Ad sınırı: **255 karakter VE 255 bayt** — `REF_STRATEGIC_OBJECTIVE` / `REF_CONTRIBUTION`
 * `NAME_TR`/`NAME_EN` kolonları `VARCHAR2(255 BYTE)`. Bayt sınırı projenin ortak aynasından gelir
 * (`COLUMN_BYTES.taskClassificationName` ↔ backend `ColumnBytes.TASK_CLASSIFICATION_NAME`).
 * Bağlayan bayt sınırıdır: 128 Türkçe harf 256 bayt eder ve karakter sınırını geçtiği hâlde kolona
 * sığmaz. İkisi de sunucudaki kuralın aynısı olmak zorunda; ayrışırsa kullanıcı burada kabul edilen
 * bir adı kaydedemez (`TEXT_TOO_LONG`).
 */
export const NAME_MAX = 255
export const NAME_MAX_BYTES = COLUMN_BYTES.taskClassificationName

/**
 * Stratejik hedef / katkı ekle-düzenle form şeması (127): nameTr zorunlu; nameEn opsiyonel. Sıra
 * (SORT_INDEX) formda yok — sıralama tablodaki ↑/↓ oklarından yapılır (oluşturmada sona atanır).
 */
export const classificationLookupFormSchema = z.object({
  nameTr: requiredText(NAME_MAX, NAME_MAX_BYTES),
  nameEn: optionalText(NAME_MAX, NAME_MAX_BYTES),
})

export type ClassificationLookupFormValues = z.infer<typeof classificationLookupFormSchema>
